// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "social.gm2",
    name: "GM² Social",
    homepage: "https://gm2.social/",
    image_id: "f5c2218d-56b4-4fc8-63bf-0ece7276d600",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/gm-social/id6502584673",
        android: "https://play.google.com/store/apps/details?id=com.gm2.app.prod&hl=en",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "gm2://home",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map